import { Report } from '../../domain';
import { ApiDataQuery, Paginated } from '../../types';
import { BaseAPIClient } from '../base-api-client';

export const ReportsAPI = {
  async fetchReport<R extends Report>(this: BaseAPIClient, id: string): Promise<R> {
    return this.get(`/reports/${id}`);
  },

  async deleteReport(this: BaseAPIClient, id: string): Promise<void> {
    await this.delete(`/reports/${id}`);
  },

  async fetchReports(
    this: BaseAPIClient,
    args: ApiDataQuery<{
      createdById?: string;
    }>,
  ): Promise<Paginated<Report>> {
    return this.get(`/reports`, {
      params: {
        ...args,
        contain: 'createdBy',
        filter: {
          createdById: args.createdById,
        },
      },
    });
  },
};
